import Grid from '@mui/material/Grid';
import {number, object} from 'prop-types';
import React from 'react';
import TextField from './TextField.jsx';

function AuthorGroup({value, index}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          name={`authors.${index}.name`}
          label="Name"
          defaultValue={value?.name}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          name={`authors.${index}.email`}
          label="Email"
          defaultValue={value?.email}
          type="email"
          rules={{
            pattern: {
              value: /^[^@]+@[^@]+\.[^@]+$/,
              message: 'Invalid email address',
            },
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          name={`authors.${index}.affiliation`}
          label="Affiliation"
          defaultValue={value?.affiliation}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          name={`authors.${index}.location`}
          label="Location"
          defaultValue={value?.location}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

AuthorGroup.propTypes = {
  value: object,
  index: number,
};

export default AuthorGroup;
